module.exports = __webpack_public_path__ + "assets/371c9f1fc353e796c3c47625e61950e6.mp3";